define('lq/dialogs/dialog',[
    'jquery'
], function ($) {
    'use strict';

    $.fn.showDialog = function () {
        return this.each(function () {
            var $element = $(this)
                .addClass('visible')
                .appendTo('body');

            var inputs = $element
                .find('select, input, textarea, button, a')
                .filter(':visible:not([disabled])'); 

            var firstInput = inputs.first();
            var lastInput = inputs.last();

            /*redirect last tab to first input*/
            lastInput.on('keydown',
                function(e) {
                    if ((e.which === 9 && !e.shiftKey)) {
                        e.preventDefault();
                        firstInput.trigger('focus');
                    }
                });

            /*redirect first shift+tab to last input*/
            firstInput.on('keydown',
                function(e) {
                    if ((e.which === 9 && e.shiftKey)) {
                        e.preventDefault();
                        lastInput.trigger('focus');
                    }
                });
        });
    };

    $.fn.closeDialog = function() {
        return this.each(function() {
            var $element = $(this);
            $element.remove();
        });
    };
    
});
